angular.module('impactx.product').controller('EClassSearchPanelCtrl', [
    'searchFilter',
    '$redirect',
    'eClass',
    'mdPanelRef',
    'trns',
    EClassSearchPanelCtrl]);

function EClassSearchPanelCtrl(searchFilter, eClass, mdPanelRef, trns) {
    let self = this;
    self.trns = trns;

    self.searchKeepFilter = function () {
        setEClassFilter();
        closePanel();
        redirect();
    };

    self.searchDeleteFilter = function () {
        searchFilter.removeFixedFilter();
        setEClassFilter();
        closePanel();
        redirect();
    };

    function closePanel() {
        mdPanelRef && mdPanelRef.close();
    }

    function setEClassFilter() {
        searchFilter.getSearchFilterData().productGroupId = impactX.isDefined(eClass, "id");
        searchFilter.selectedEClass = eClass;
    }

    function redirect() {
        searchFilter.redirectToDialogOrList(true);
    }
}